import contentRequest from '~/src/api/requests/contentRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

export interface IAnswere {
    id: number,
    question_id: number,
    title: string,
    label_value: string,
    order: number,
}

export interface IQuestion {
    id: number,
    quiz_id: number,
    title: string,
    subtitle: string,
    label: string,
    product: string,
    multiple: number,
    order: number,
    answere: IAnswere[],
}

export interface IQuiz {
    alias: string,
    available: number,
    available_auth: number,
    available_new: number,
    title: string,
    questions: IQuestion[],
}

export type TDataResponse = TResponse<IQuiz, any>;

export const getQuiz = async(domainCity: string, aliasForQuiz: string): Promise<TDataResponse> => {
    const url = `${domainCity}/v1/quiz/view?id=${aliasForQuiz}`;

    try {
        const response = await contentRequest.getWithCache(url);

        return {
            isSuccess: true,
            payload: response.data
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
